import React from 'react';
import DiscountMessage from './discount_message';
import WinterSaleBanner from '../components/WinterSaleBanner';
import UpgradeInformation from '../mobile_personal_upgrade/upgrade_information.jsx';
import ProductSelector from './product_selector/product_selector';
import ProductSelectorExpMobile from './product_selector/product_selector_mobile_exp';

const upgradeInformation = (props) =>
  props.context.context != 'global' ? (
    <UpgradeInformation
      products={props.products}
      currencySymbol={props.staticData.site.currency_symbol}
      localisations={props.localisations}
      experiments={props.experiments}
    />
  ) : null;

const PersonalProductsView = (props) => (
  <section className="products">
    {props.context.context != 'contact_advertiser' ? (
      <div className="mobile-upgrade-info">{upgradeInformation(props)}</div>
    ) : null}
    {props.winterSale ? <WinterSaleBanner /> : null}
    <menu className="products__options products__options--vertical-variation">
      <h4 className="inline-payment__heading">
        {props.context.context == 'contact_advertiser' ? 2 : 1}.{' '}
        {props.localisations.choose_your_upgrade}
      </h4>
      <DiscountMessage
        discounts={props.discounts}
        inlinePayment={true}
        localisations={props.localisations}
      />
      {props.experiments.success_guarantee_experiment_mobile ? (
        <ProductSelectorExpMobile
          updateCart={props.updateCart}
          currentProduct={props.currentProduct}
          products={props.products}
          currencySymbol={props.staticData.site.currency_symbol}
          context={props.context}
          customer={props.staticData.customer}
          miscellaneous={props.staticData.miscellaneous}
          localisations={props.localisations}
          experiments={props.experiments}
        />
      ) : (
        <ProductSelector
          updateCart={props.updateCart}
          currentProduct={props.currentProduct}
          products={props.products}
          currencySymbol={props.staticData.site.currency_symbol}
          context={props.context}
          customer={props.staticData.customer}
          miscellaneous={props.staticData.miscellaneous}
          localisations={props.localisations}
          experiments={props.experiments}
        />
      )}
    </menu>
  </section>
);

export default PersonalProductsView;
